import React, { useState, useEffect } from "react";
import { DownOutlined } from "@ant-design/icons";
import { useQuery, useMutation } from "@apollo/client";
import { Menu, Dropdown, Switch } from "antd";
import dateFormat from "dateformat";
import ViewQualificationss from "./ViewQualification";
import EditQualifications from "./EditQualifications";
import { Select } from "antd";
import {
  Fetch,
  getClientId,
  managerQualifications,
  Qualification_Run,
  Fetches,
  Qualification_Record_Query,
  Qualification_View_Query,
  Update_Qualification,
  Update_deactivate_Qualification,
} from "../../../Queries/Manager Query/Manager_Qualification/Manager_Qualification";
import AddQualification from "./AddQualification";
import firebase from "../../../Firebase/firebase";
const Qualifications = () => {
  const [search, setsearch] = useState("");
  const [add_new_qualification, setadd_new_qualification] = useState(false);
  const [toggle, settoggle] = useState(true);
  const [EditQualification, setEditQualification] = useState(false);
  const [ViewQualification, setViewQualification] = useState(false);
  const [currentFormData, setCurrentFormData] = useState({});
  const [validateToggle, setvalidateToggle] = useState(true);
  const [dropdown2, setdropdown2] = useState("");
  const [users, setusers] = useState({});
  useEffect(() => {
    firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        const token = await user.getIdToken();
        const idTokenResult = await user.getIdTokenResult();
        setusers({
          user: user,
          token: idTokenResult,
          jwt: token,
        });
      } else console.log("SIGNED OUT");
    });
  }, []);
  const { data: getclient } = useQuery(getClientId, {
    variables: { id: users?.token?.claims?.user_id },
  });
  const { data: managerqualication } = useQuery(managerQualifications, {
    variables: { id: users?.token?.claims?.user_id },
  });
  const { data: Qualification_Query } = useQuery(Qualification_Record_Query, {
    variables: {
      active: toggle,
      validate: validateToggle,
      id: getclient?.aatmsv4_users[0]?.client.clientsid,
      qid: dropdown2[0],
    },
  });
  const { data: da } = useQuery(Fetch);
  const { data: das } = useQuery(Fetches);
  const { data: ViewQualifications } = useQuery(Qualification_View_Query, {
    variables: { id: currentFormData?.qrid },
  });
  const [UpdateQualication, { data: datt }] = useMutation(
    Update_Qualification,
    {
      refetchQueries: [
        { query: Fetches },
        { query: Fetch },
        {
          query: Qualification_Record_Query,
          variables: {
            active: true,
            validate: true,
            id: getclient?.aatmsv4_users[0]?.client.clientsid,
          },
        },
        {
          query: Qualification_Record_Query,
          variables: {
            active: true,
            validate: false,
            id: getclient?.aatmsv4_users[0]?.client.clientsid,
          },
        },
        {
          query: Qualification_View_Query,
          variables: { id: currentFormData?.qrid },
        },
      ],
    }
  );
  const [UpdateQualicationDeactivate, { data: datts }] = useMutation(
    Update_deactivate_Qualification,
    {
      refetchQueries: [
        { query: Fetches },
        { query: Fetch },
        {
          query: Qualification_Record_Query,
          variables: {
            active: toggle,
            validate: true,
            id: getclient?.aatmsv4_users[0]?.client.clientsid,
          },
        },
        {
          query: Qualification_Record_Query,
          variables: {
            active: false,
            validate: false,
            id: getclient?.aatmsv4_users[0]?.client.clientsid,
          },
        },
        {
          query: Qualification_View_Query,
          variables: { id: currentFormData?.qrid },
        },
      ],
    }
  );
  const [Qualify_run, { data: d }] = useMutation(Qualification_Run, {
    refetchQueries: [
      { query: Fetches },
      { query: Fetch },
      {
        query: Qualification_Record_Query,
        variables: { active: toggle, validate: validateToggle },
      },
      {
        query: Qualification_Record_Query,
        variables: { active: toggle, validate: validateToggle },
      },
      {
        query: Qualification_View_Query,
        variables: { id: currentFormData?.qrid },
      },
    ],
  });

  const Dates = new Date();
  const date = dateFormat(Dates, "isoDate");
  useEffect(() => {
    Qualify_run({
      variables: { dates: date },
    });
  }, []);
  const add_new = () => {
    setadd_new_qualification(true);
  };
  const togle = () => {
    toggle ? settoggle(false) : settoggle(true);
  };
  const valid = () => {
    validateToggle ? setvalidateToggle(false) : setvalidateToggle(true);
  };
  const Edit = () => {
    setEditQualification(true);
  };
  const View = () => {
    setViewQualification(true);
  };
  const closeForm = () => {
    setadd_new_qualification(false);
    setViewQualification(false);
    setEditQualification(false);
  };
  const menu = (el) => (
    <Menu>
      <Menu.Item>
        <p
          onClick={() => {
            setCurrentFormData(el);
            View();
          }}
        >
          View
        </p>
      </Menu.Item>
      <Menu.Item>
        <p
          onClick={() => {
            setCurrentFormData(el);
            Edit();
          }}
        >
          Edit
        </p>
      </Menu.Item>
    </Menu>
  );
  const Option = Select.Option;
  return (
    <div className="animate__animated animate__fadeIn">
      {/* Qualification table */}
      <div
        className={
          "qualifications-container " +
          (add_new_qualification || EditQualification || ViewQualification
            ? "hide-element"
            : "")
        }
      >
        <div className="category-title">Qualifications</div>
        <button className="submit-button" onClick={() => add_new()}>
          Add New Qualification
        </button>
        <div className="table-body-container">
          <div className="table-body-header">All Qualifications</div>
          <div className="client-list-divider"></div>
          <div className="table-container">
            <div className="table-header-container">
              <div className="display-record">
                {/* <span>Show</span> */}
                <Select
                  value={
                    dropdown2[1]
                      ? `${dropdown2[1]} : ${dropdown2[2]}`
                      : "Select your Qualification"
                  }
                  onChange={(e) => setdropdown2(e)}
                >
                  {managerqualication?.aatmsv4_qmap?.map((el, i) => (
                    <Option
                      key={i}
                      value={[
                        el?.qualification?.qid,
                        el?.qualification?.qcode,
                        el?.qualification?.qualification,
                      ]}
                    >
                      {el?.qualification?.qcode}:{" "}
                      {el?.qualification?.qualification}
                    </Option>
                  ))}
                </Select>
              </div>
              <div className="active-switch">
                <span>Validated</span>
                <Switch onClick={valid} defaultChecked />
              </div>
              <div className="active-switch">
                <span>Active</span>
                <Switch onClick={togle} defaultChecked />
              </div>
              <div className="search-bar">
                <span>Search</span>
                <input
                  type="text"
                  value={search}
                  onChange={(e) => setsearch(e.target.value)}
                />
              </div>
            </div>
            {dropdown2 === ""
              ? null
              : Qualification_Query?.aatmsv4_qualificationrecords?.map(
                  (data, index) => {
                    if (
                      data?.crew?.name
                        .toLowerCase()
                        .includes(search.toLowerCase())
                    ) {
                      return (
                        <div className="table-row-container" key={index}>
                          <div className="table-row-top">
                            <div className="items">
                              <div className="title">E-Code</div>
                              <div className="value">{data?.crew?.ecode}</div>
                            </div>
                            <div className="items">
                              <div className="title">Name</div>
                              <div className="value">{data?.crew?.name}</div>
                            </div>
                            <div className="items">
                              <div className="title">Aircraft Name</div>
                              <div className="value">
                                {data?.crew?.fleet?.aircraft}
                              </div>
                            </div>
                            <div className="items">
                              <div className="title">Q-Code</div>
                              {/* <div className="value">{data?.qcode}</div> */}
                              <Dropdown overlay={menu(data)}>
                                <a
                                  className="ant-dropdown-link"
                                  onClick={(e) => e.preventDefault()}
                                  id="uploadQualifications-dropdown"
                                >
                                  <div className="value">
                                    {data?.qcode}
                                    <DownOutlined />
                                  </div>
                                </a>
                              </Dropdown>
                            </div>
                            <div className="items">
                              <div className="title">Document Number</div>
                              <div className="value">
                                {data?.documentnumber}
                              </div>
                            </div>
                            <div className="items">
                              <div className="title">Issue Date</div>
                              <div className="value">{data?.issuedate}</div>
                            </div>
                            <div className="items">
                              <div className="title">Valid Date</div>
                              <div className="value">{data?.validdate}</div>
                            </div>

                            {/* <Dropdown overlay={menu(data)}>
                          <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                            <i className="fa fa-ellipsis-h" />
                            <DownOutlined />
                          </a>
                        </Dropdown> */}
                          </div>
                        </div>
                      );
                    }
                  }
                )}
            {}
          </div>
        </div>
        {/* <div className="print-email-container">
          <button className="submit-button" style={{ marginTop: "unset" }}>
            <i className="fa fa-download" />
            Download
          </button>
          <button className="print-button">
            <i className="fa fa-print" />
            Print
          </button>
          <button className="email-button">
            <i className="fa fa-envelope" />
            Email
          </button>
                </div>*/}
      </div>
      {/* add new qualification form */}
      <div className={add_new_qualification ? "" : "hide-element"}>
        <AddQualification
          Qualification_View_Query={Qualification_View_Query}
          Edit={Edit}
          EditQualification={EditQualification}
          closeForm={closeForm}
          toggle={toggle}
          validate={validateToggle}
          Qualification_Record_Query={Qualification_Record_Query}
        />
      </div>
      <div className={ViewQualification ? "" : "hide-element"}>
        <ViewQualificationss data={ViewQualifications} close={closeForm} />
      </div>
      <div className={EditQualification ? "" : "hide-element"}>
        <EditQualifications
          UpdateQualicationDeactivate={UpdateQualicationDeactivate}
          UpdateQualication={UpdateQualication}
          datas={currentFormData?.qrid}
          data={ViewQualifications}
          close={closeForm}
        />
      </div>
    </div>
  );
};
export default Qualifications;
